// startup
// Load entry module and return exports
__webpack_require__("./node_modules/aurelia-webpack-plugin/runtime/empty-entry.js");
__webpack_require__("./node_modules/aurelia-webpack-plugin/runtime/pal-loader-entry.js");
__webpack_require__("./node_modules/aurelia-bootstrapper/dist/native-modules/aurelia-bootstrapper.js");
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("app/views/app/anonymous/anonymous");
